import type { TNavbarMenuListElement, TNavbarMenuListGroupElement } from '@shared/dream-components';
import { NavbarMenuListGroupV2 as NavbarMenuListGroupElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TNavbarMenuListGroupElement;
  parent?: TNavbarMenuListElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuListGroup = ({ node, children, screen, parent }: Props) => {
  return (
    <NavbarMenuListGroupElement element={node} screen={screen} parent={parent}>
      {children}
    </NavbarMenuListGroupElement>
  );
};

export default NavbarMenuListGroup;
